import { type Theme, Typography, styled, useTheme } from '@mui/material';
import { yellow } from '@mui/material/colors';
import { type SystemStyleObject } from '@mui/system';
import { getStarIcon } from './helpers/getStarIcon.ts';

const Container = styled('span')({
  alignItems: 'center',
  display: 'flex',
});

export type SmallProps = {
  sx?: SystemStyleObject<Theme>;
  voteAverage: number;
};

export const Small = ({ sx = {}, voteAverage }: SmallProps) => {
  const theme = useTheme();
  const StarIcon = getStarIcon(voteAverage);

  return (
    <Container sx={sx}>
      <StarIcon
        sx={{
          color: yellow[600],
          fontSize: '1.3rem',
          marginRight: theme.spacing(0.2),
        }}
      />
      <Typography
        className="voteAverageText"
        sx={{
          color: theme.mainTextPrimary,
          display: 'inline-block',
        }}
        variant="body2"
      >
        {voteAverage.toFixed(1)}
      </Typography>
    </Container>
  );
};
